// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__7nNsV","box":"modal_box__IDvPJ"};